import { render, staticRenderFns } from "./CreateEditRole.vue?vue&type=template&id=5ada0cc9&"
import script from "./CreateEditRole.vue?vue&type=script&lang=js&"
export * from "./CreateEditRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports